// Vuex
import Request from './request';

async function fetch(data) {
    return Request('get', "api/cloud-prints/", data);
}

async function add(data) {
    return Request('post', 'api/cloud-prints/add', data)
}

async function edit(data) {
    return Request('post', 'api/cloud-prints/edit', data)
}

async function del(data) {
    return Request('post', 'api/cloud-prints/del', data)
}

async function imports(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/cloud-prints/import", data);
}

async function getSetting() {
    return Request('get', "api/cloud-prints/get-setting");
}

async function saveSetting(data) {
    return Request('post', "api/cloud-prints/save-setting", data);
}


export default {
    fetch,
    add,
    edit,
    del,
    imports,
    getSetting,
    saveSetting,
};